export interface CompanyInvoice {
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  id: string;
  companyId: string;
  subscriptionId: string;
  subscriptionVersion: number;
  status: string;
  amountDue: number;
  amountPaid: number;
  quantity: number;
  originalCreated: number;
  pdfUrl: string;
  paidAt: number;
  latestEventCreated: number;

  amountToBePaidFormatted?: number;
  amountPaidFormatted?: number;
  paidAtFormatted?: string;
}
